<template>
  <div class="form_overlay" @click="closePopup"></div>
  <div id="popupForget1">
    <form @submit.prevent="submitform">
      <div class="popupForget">
        <h2>Business Login</h2>

        <div class="field-of-input">
          <input v-model="company_code" type="text" placeholder=" " class="textbox-input" required />
          <label class="form_Label-css" for="">Enter Your Company Code</label>
        </div>
        <div class="field-of-input">
          <input v-model="email" type="text" placeholder=" " class="textbox-input" required />
          <label class="form_Label-css" for="">Enter Your Email</label>
        </div>
        <div class="field-of-input">
          <input v-model="password" type="text" placeholder=" " class="textbox-input" required />
          <label class="form_Label-css" for="">Enter Your Password</label>
        </div>
        <br />
        <br />
        <button class="CreateRoom" :disabled="buttonDisabled">Log in </button>
        <!-- <p class="timer" v-if="showTimer" style="color: darkorange">Your password reset link has been sent to your registered email address. You can request another reset link after {{ minutes }} minutes and {{ seconds }} seconds</p> -->
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "adminLogin",

  data() {
    return {
      email: "",
      company_code: '',
      password: '',
      showPopupForget1: true,
      buttonDisabled: false,
      showTimer: false,
      minutes: 0,
      seconds: 0,
      disabledEmail: "",
      disabledTimestamp: 0,
      showForm: false, // Controls the visibility of the form
    };
  },
  mounted() {
    // Retrieve the email and timer state from localStorage when the component is mounted
    const storedEmail = localStorage.getItem("disabledEmail");
    if (storedEmail) {
      this.disabledEmail = storedEmail;
      this.disabledTimestamp = parseInt(localStorage.getItem("disabledTimestamp"));
      if (this.isWithin10Minutes()) {
        this.buttonDisabled = true;
        this.showTimer = true;
        this.startTimer();
      } else {
        this.resetDisabledState();
      }
    }
  },
  methods: {
    async submitform() {
      if (!this.email) {
        alert("Please enter an email.");
        return;
      }
      try {
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}admin/login-admin`, {
          email: this.email,
          company_code: this.company_code,
          password: this.password
        }, {
          withCredentials: true
        });
        if (response.data.success) {
          const user = response.data.data;
          const token = response.data.token;
          console.log("token:", token);
          console.log("user:", user);
          // Save everything synchronously
          localStorage.setItem("user", JSON.stringify(user));
          sessionStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("token", token);
          sessionStorage.setItem("token", token);

          // Update Vuex immediately before navigating
          await this.$store.commit("setuserDetails", user);
          await this.$store.commit("setUserRole", user.role);
          await this.$store.commit("set_user_id", user._id);
          await this.$store.dispatch("isTokenExpired");
          await this.$store.dispatch('setUserRoleAndFetchPermissions', user.role);
          await new Promise((resolve) => setTimeout(resolve, 500));
          console.log(user.role);
          if (user.role === "director") {
            await this.$router.push(`/business/${this.company_code}`);
          } else if (user.role === "driver") {
            await this.$router.push(`/driver/${user.company_code}/${user.userId}`);
          } else if (user.role === "doctor") {
            sessionStorage.setItem(
              "doctorParams",
              JSON.stringify({
                companyCode: user.company_code,
                candidateEmail: user.candidateEmail,
              })
            );
            await this.$router.push("/company-doctor");
          } else {
            sessionStorage.setItem(
              "employeeParams",
              JSON.stringify({
                companyCode: user.company_code,
                candidateEmail: user.candidateEmail,
              })
            );
            
            window.location.href = `https://employee.mydoctorsportal.com/employee`;
          }
          
        }
      } catch (error) {
        alert(error);
        console.error("Error", error);
      }
    },
    resetDisabledState() {
      this.disabledEmail = "";
      this.disabledTimestamp = 0;
    },
    isWithin10Minutes() {
      return Date.now() - this.disabledTimestamp < 10 * 60 * 500; // Check if less than 10 minutes
    },
    reset() {
      this.email = "";
    },
    closePopup() {
      this.$emit('close');
      document.body.classList.remove("no-scroll"); // Enable scrolling
    },
  },
};
</script>

<style scoped>
@import url(./Login.css);
</style>